import {LVDataLayerHelper} from "./LVDataLayerHelper";

export const pushToAdobeDataLayer = (): void => {

    const key = "adobeDataLayer";
    const storedData = sessionStorage.getItem(key);

    if (!storedData) { return; }

    const values = safelyParseJSON(storedData);
    const interaction = values.interaction;

    new LVDataLayerHelper().mapInteractionToDataLayer(interaction);

    (window as any).adobeDataLayer = (window as any).adobeDataLayer || [];

    (window as any).adobeDataLayer.push({
        event: values.event || "",
        quoteInfo: removeNullValues((window as any).LvDataLayer || {})
    });


    sessionStorage.removeItem(key);

    function safelyParseJSON(data: string | null): Record<string, any> {
        try {
            return data ? JSON.parse(data) : {};
        } catch {
            console.warn("Invalid JSON in sessionStorage:", key);
            return {};
        }
    }

    function removeNullValues(obj: any): any {
        if (typeof obj !== "object" || obj === null) { return obj; }

        return Array.isArray(obj)
            ? obj.map(removeNullValues).filter(item => item != null)
            : Object.fromEntries(
                Object.entries(obj)
                    .map(([k, v]) => [k, removeNullValues(v)])
                    .filter(([_, v]) => v != null)
            );
    }
};

export function pushToAdobeDataLayerDelayed(delay: number): any {
    return setTimeout(() => {
        pushToAdobeDataLayer();
    }, delay);
}




// WEBPACK FOOTER //
// ./src/utils/AdobeDataLayerHelper.ts